export const EMPTY_STATE_TEXT = "Drag items here.";
